module.exports = __webpack_public_path__ + "static/media/tag.a95b7b86.svg";